import * as React from 'react';
import {
    Edit,
    FormTab,
    SaveButton,
    TabbedForm,
    Toolbar,
    useNotify,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { useQueryClient } from '@tanstack/react-query';
import { CampaignFormFields, campaignTransform } from './CampaignFormFields';
import CampaignResponses from './CampaignResponses';
import CampaignDailyReport from './CampaignDailyReport';
import CampaignExportHistory from './CampaignExportHistory';

const CampaignToolbar = () => {
    const { reset } = useFormContext();
    const notify = useNotify();
    const queryClient = useQueryClient();
    return (
        <Toolbar>
            <SaveButton
                type="button"
                mutationOptions={{
                    onSuccess: async data => {
                        reset(data);
                        await queryClient.invalidateQueries({
                            queryKey: ['campaign-responses', data.guid],
                        });
                        notify('ra.notification.updated', {
                            type: 'info',
                            messageArgs: { smart_count: 1 },
                        });
                    },
                }}
            />
        </Toolbar>
    );
};

const CampaignEdit = () => (
    <Edit
        transform={campaignTransform}
        mutationMode="pessimistic"
        redirect={false}
        queryOptions={{ refetchOnMount: 'always' }}
    >
        <TabbedForm toolbar={<CampaignToolbar />}>
            <FormTab label="resources.campaign.tabs.details">
                <CampaignFormFields />
            </FormTab>
            <FormTab label="resources.campaign.tabs.responses">
                <CampaignResponses />
            </FormTab>
            <FormTab label="resources.campaign.tabs.daily_report">
                <CampaignDailyReport />
            </FormTab>
            <FormTab label="resources.campaign.tabs.export_history">
                <CampaignExportHistory />
            </FormTab>
        </TabbedForm>
    </Edit>
);

export default CampaignEdit;
